import { FancySharePublicDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfilePublicRelayDto } from '@diritto/common/relay/dtos/profile-relay.dtos';
import { JsonLd } from 'app-components/common/JsonLd';
import { useMemo } from 'react';
import { configure } from 'utils/configure';
import { generateImageUrl } from 'utils/generateImageUrl';
import { getFullUrl } from 'utils/url';

export const FancyShareJsonLd = ({
  fancyShare,
  content,
  authorProfile,
}: {
  fancyShare: FancySharePublicDto;
  content: ContentPublicRelayDto;
  authorProfile?: ProfilePublicRelayDto;
}) => {
  const openImageUrlOriginal = `${configure.dynamicCdnPublicUrl}/fancy-shares/og?url=${encodeURIComponent(
    generateImageUrl({
      path: fancyShare.file.path,
      isPrivate: fancyShare.file.isPrivate,
      transformation: {
        original: true,
      },
    }),
  )}`;
  const openImageUrl = openImageUrlOriginal;

  const url = useMemo(() => getFullUrl(`/fancy-shares/${fancyShare.id}`), [fancyShare.id]);

  const titleAndAuthorName = `${content?.title ? `<${content.title}> - ` : ''}${authorProfile?.nickname ?? ''}`;

  return (
    <JsonLd
      data={{
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article',
        },
        headline: titleAndAuthorName,
        image: [openImageUrl],
        url,
        description: fancyShare.description,
      }}
    />
  );
};
